/**
 * Created by Rick on 10/20/2023.
 */

export class EditRelationshipDialogOpenOptions {
    oldRelationshipTypeId: string;
    oldRelationshipTypeName: string;
    relationshipTypeId: string;
}
